module.exports = __webpack_public_path__ + "img/noinfo.36e9a64f.png";